//
// Game
//
// Plumbs components together once they have all loaded

// fix for gradients that was fixed in a later version of pixi
(function () {
  function applyPixiGradientFix() {
    if (typeof PIXI === "undefined" || !PIXI.Text || !PIXI.Text.prototype._generateFillStyle) {
      return false;
    }
    var _orig = PIXI.Text.prototype._generateFillStyle;
    PIXI.Text.prototype._generateFillStyle = function (style, lines) {
      var padding = (style && style.padding) || 0;
      if (!Array.isArray(style && style.fill) || padding === 0) {
        return _orig.call(this, style, lines);
      }
      var ctx = this.context;
      var _origCLG = ctx.createLinearGradient;
      ctx.createLinearGradient = function (x0, y0, x1, y1) {
        if (x0 === x1 && y0 === 0 && y1 > 0) {
          return _origCLG.call(ctx, x0, padding, x1, y1 - padding);
        }
        return _origCLG.call(ctx, x0, y0, x1, y1);
      };
      var result = _orig.call(this, style, lines);
      ctx.createLinearGradient = _origCLG;
      return result;
    };
    return true;
  }

  if (!applyPixiGradientFix()) {
    window.addEventListener("load", applyPixiGradientFix);
  }
})();

game = {};
gameData = {};

game.timeScale = 1;

gameData.gameName = "Big Game Fishing Rapid Riches";
gameData.gameVersionMajor = "1";
gameData.gameVersionMinor = "1";
gameData.gameVersionBugFix = "106";
gameData.gameReleaseDate = "22/06/2026"; // update me upon release

gameData.version = `${gameData.gameVersionMajor}.${gameData.gameVersionMinor}.${gameData.gameVersionBugFix}`;

///////////////////////
// Developer options //
///////////////////////#

let devMode = false;
Reflex.developerModeData.checkUnusuedResources = devMode;
Reflex.developerModeData.highlightTranslatedText = devMode;
Reflex.developerModeData.showButtonHitAreas = devMode;
Reflex.developerModeData.fastSpin = devMode;

///////////////////////

gameData.symbolWidth = 156;
gameData.symbolHeight = 156;
gameData.appertureSize = 156;
gameData.numReels = 5;
gameData.numRows = 3;

gameData.themeTuneId = undefined;
gameData.freespinsThemeTuneId = undefined;
gameData.mainTunePlaying = false;
game.sideMenuOpen = false;

game.currentSplashPage = 0;
// game.splashScreenShowing = false;

gameData.convertStringToSegmentId = function (str) {
  switch (str) {
    case "segmentGreen": {
      return gameData.segmentDollar;
    }
    case "segmentYellow": {
      return gameData.segmentBigWin;
    }
    case "segmentBlue": {
      return gameData.segmentBonus;
    }
    case "segmentRed": {
      return gameData.segmentFreespins;
    }
    case "fsSegmentMega": {
      return gameData.fsSegmentMega;
    }
    case "fsSegmentSuper": {
      return gameData.fsSegmentSuper;
    }
    case "fsSegmentMidi": {
      return gameData.fsSegmentMidi;
    }
    case "fsSegmentMinor": {
      return gameData.fsSegmentMinor;
    }
    case "fsSegmentMini": {
      return gameData.fsSegmentMini;
    }
    case "fsSegment3Fs": {
      return gameData.fsSegment3Fs;
    }
    case "fsSegment5Fs": {
      return gameData.fsSegment5Fs;
    }
    case "fsSegment8Fs": {
      return gameData.fsSegment8Fs;
    }
    default: {
      console.log("");
    }
  }
};

game.autoplayPopupOpen = false;

game.splashScreenDone = false;

game.onCreditChanged = function (creditTask) {
  gameData.creditMeter.set(creditTask.data.balance);
  gameData.credit = creditTask.data.balance;
};

game.createGameVersion = function () {
  var versionString =
    gameData.gameName +
    " v" +
    gameData.gameVersionMajor +
    "." +
    +gameData.gameVersionMinor +
    "." +
    gameData.gameVersionBugFix;
  console.log(versionString);
};

game.initialise = function (gameConfigTask) {
  // --------------------------------------------------------------------------------------------
  // All game data has been loaded, initial layout has been set, and gameData has been populated.
  // Time to link everything together.
  // --------------------------------------------------------------------------------------------
  var i;

  // Create the game version text
  game.createGameVersion();

  gameData.gameConfig = gameConfigTask.data;

  // Set initial state
  resourceManager.getController("inputOverlord").setState("enabled");

  // Hide all screens except loading. These will be shown when loading continues
  resourceManager.getContainer("gameContainer").visible = false;
  resourceManager.getContainer("DemoContainer").visible = false;
  resourceManager.getContainer("gameButtonContainer").visible = false;
  // resourceManager.getContainer("specialButtonContainer").visible = false;

  gameData.stakes = [];
  gameData.multipliedStakes = [25, 50, 75, 100, 125, 250, 375, 625, 1000, 1250, 1875, 2500, 3125, 3750, 6250, 12500];
  gameData.coinSizes = [];
  gameData.currentStakeIndex = gameConfigTask.data.slotConfig.coinSizes.indexOf(
    gameConfigTask.data.slotConfig.defaultAmountPerLine
  );
  gameData.numLines = gameConfigTask.data.slotConfig.defaultNumLines;
  for (i = 0; i < gameConfigTask.data.slotConfig.coinSizes.length; i++) {
    gameData.stakes.push(gameConfigTask.data.slotConfig.coinSizes[i] * gameConfigTask.data.slotConfig.defaultNumLines);
    gameData.coinSizes.push(gameConfigTask.data.slotConfig.coinSizes[i]);
  }

  // gameData.creditMeter = resourceManager.get("creditContainer:creditMeter");
  // gameData.winningsMeter = resourceManager.get("winningsContainer:winningsMeter");
  // gameData.stakeMeter = resourceManager.get("betContainer:BetMeter");

  gameData.stakeMeter = resourceManager.get("meterContainer:stake:meter");
  gameData.creditMeter = resourceManager.get("meterContainer:credit:meter");
  gameData.winningsMeter = resourceManager.get("meterContainer:winnings:meter");
  gameData.winningsMeterTitle = resourceManager.get("meterContainer:winnings:title");

  gameData.multiplierValues = [2, 3, 4, 5, 10, 20, 50, 100];

  // game.changeStake(gameData.stakes[gameData.currentStakeIndex]);
  // if (gameData.LastGameMode === 1) {
  //   gameData.encoreEnabled = true;

  //   // Put button in the right state if not already true
  //   resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton").setRecovery();
  // }

  messageBus.subscribe("common:BalanceEvent", game.onCreditChanged);
  messageBus.subscribe("game:modal", game.modal);
  messageBus.subscribe("game:sideMenuOpen", game.sideMenuOpenMsg);
  messageBus.subscribe("game:sideMenuClosed", game.sideMenuClosedMsg);
  messageBus.subscribe("game:backFromReplay", game.backFromReplay);
  Reflex.registerEventHandler("orientationChange", game.onOrientationChange);
  Reflex.registerEventHandler("resize", game.onResize);

  gameController.initialise(gameConfigTask);

  if (gameData.recoveryStake) {
    game.changeStake(gameData.recoveryStake);
    gdk.playerChangedStake(gameData.recoveryStake);
    gameController.inRecovery = true;
    if (gameData.recoveryMode === "LUCKYBET_BUY") {
      const stakeController = resourceManager.getController("stakeController");
      stakeController.requestChangeStake(gameData.recoveryStake / 1.5);
      resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton").toggleOn(true);
    }
  } else if (gameData.previousStakeAndMode != null) {
    const { lastCashStake, lastGameMode } = gameData.previousStakeAndMode;
    if (lastGameMode === 0 || lastGameMode === 1) {
      game.changeStake(lastCashStake);
      gdk.playerChangedStake(lastCashStake);
    } else {
      game.changeStake(gameData.stakes[gameData.currentStakeIndex]);
      gdk.playerChangedStake(gameData.stakes[gameData.currentStakeIndex]);
    }
    if (lastGameMode === 1) {
      resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton").toggleOn(true);
    }
  } else {
    game.changeStake(gameData.stakes[gameData.currentStakeIndex]);
    gdk.playerChangedStake(gameData.stakes[gameData.currentStakeIndex]);
  }

  // Kick off the game
  game.onOrientationChange();
  gameController.start();
};

game.sideMenuOpenMsg = function () {
  game.sideMenuOpen = true;
};

game.sideMenuClosedMsg = function () {
  game.sideMenuOpen = false;
};

game.onResize = function () {
  if (gameData.gameMask) {
    if (systemData.isLandscape) {
      gameData.gameMask.scale.x = 1280;
      gameData.gameMask.scale.y = 720;
    } else {
      gameData.gameMask.scale.x = 720;
      gameData.gameMask.scale.y = 1280;
    }
  }
};

game.onOrientationChange = function () {
  if (game.slideShowActive) {
    game.updateSplashScreen();
  }

  if (game.splashScreenDone) {
    switch (layoutController.getCurrentLayout()) {
      case "landscape_default":
      case "landscape_mobile": {
        resourceManager.getContainer("backgroundContainer").visible = true;
        resourceManager.getContainer("backgroundContainerPortrait").visible = false;
        break;
      }
      case "portrait_default":
      case "portrait_mobile": {
        resourceManager.getContainer("backgroundContainer").visible = false;
        resourceManager.getContainer("backgroundContainerPortrait").visible = true;
        break;
      }
    }
  }
};

game.onCloseTutorial = function () {
  const bgContainer = resourceManager.getContainer("backgroundContainer");
  bgContainer.visible = true;
  gameData.gameMask = new PIXI.Graphics();
  gameData.gameMask.beginFill(0xffffff);
  gameData.gameMask.lineStyle(0, 0xffffff);
  gameData.gameMask.drawRect(0, 0, 1, 1);
  bgContainer.addChild(gameData.gameMask);
  systemData.gameContainer.mask = gameData.gameMask;

  if (gameData.recoveryStake) {
    let mode = undefined;
    if (gameData.recoveryMode === "LUCKYBET_BUY") {
      gameData.encoreEnabled = true;
      mode = gameData.recoveryMode;
    } else if (gameData.recoveryMode === "BONUS_BUY_LOW") {
      mode = gameData.recoveryMode;
      gameController.inBuyABonus = true;
      gameController.inBuyABonusLow = true;
    } else if (gameData.recoveryMode === "BONUS_BUY_MEDIUM") {
      mode = gameData.recoveryMode;
      gameController.inBuyABonus = true;
      gameController.inBuyABonusMed = true;
    } else if (gameData.recoveryMode === "BONUS_BUY_HIGH") {
      mode = gameData.recoveryMode;
      gameController.inBuyABonus = true;
      gameController.inBuyABonusHigh = true;
    }

    const stakeController = resourceManager.getController("stakeController");
    stakeController.requestChangeStake(gameData.recoveryStake / (gameData.encoreEnabled ? 1.5 : 1), mode);
    game.changeStake(gameData.recoveryStake);
  }

  game.goToGame();
};

/**
 * Hide the loading screen and show the splash screen
 */
game.goToSplash = function () {
  const loadingContainer = resourceManager.getContainer("loadingContainer");
  loadingContainer.visible = false;

  resourceManager.getContainer("splashContainer").visible = true;
  resourceManager.get("infoContainer2").visible = false;

  var background = resourceManager.get("splashBackgroundL");
  var portrait_background = resourceManager.get("splashBackgroundP");

  background.interactive = true;
  portrait_background.interactive = true;

  background.on("mouseup", function () {
    game.progressCurrentSplashScreen();
    return;
  });
  background.on("touchend", function () {
    game.progressCurrentSplashScreen();
    return;
  });
  portrait_background.on("mouseup", function () {
    game.progressCurrentSplashScreen();
    return;
  });
  portrait_background.on("touchend", function () {
    game.progressCurrentSplashScreen();
    return;
  });
};

//Progress through splash screens
game.progressCurrentSplashScreen = function () {
  var screen1 = resourceManager.get("infoContainer1");
  var screen2 = resourceManager.get("infoContainer2");
  game.currentSplashPage++;

  if (!gdk.getPlatformAllowsUpstake()) {
    game.currentSplashPage++;
  }

  switch (game.currentSplashPage) {
    case 1:
      screen1.visible = false;
      screen2.visible = true;
      soundManager.play("genericClick");
      break;
    default:
      game.splashScreenShowing = false;
      soundManager.play("genericClick");
      gdk.loadingClosed();
      game.goToGame();
  }
};

game.goToGame = function () {
  if (gdk.deviceInfo.chrome) {
    var chromeVersion = Number(
      String(gdk.deviceInfo.version).substring(0, String(gdk.deviceInfo.version).indexOf("."))
    );
    if (chromeVersion >= 55) {
      // Chrome will only start audio on a touch
      Howler.ctx.resume();
    }
  }

  game.slideShowActive = false;

  timerManager.stop(game.slideshowTimer);

  gameData.mainTunePlaying = true;

  resourceManager.getContainer("loadingContainer").visible = false;
  resourceManager.getContainer("gameContainer").visible = true;
  resourceManager.getContainer("backgroundContainer").visible = true;
  resourceManager.getContainer("msgBoxPopupContainer").visible = true;
  resourceManager.getContainer("gameButtonContainer").visible = true;
  resourceManager.getContainer("particleContainer").visible = true;
  resourceManager.getContainer("buyABonusContainer").visible = true;
  resourceManager.getContainer("settingsMenuContainer").visible = true;
  resourceManager.getContainer("splashContainer").visible = false;
  resourceManager.getContainer("loadingContainer").visible = false;
  resourceManager.get("maxWinPopup").visible = false;

  gameData.helpPageScroll = resourceManager.get("helpPageScrollContainer:helpPageScroll");
  gameData.winningsText = resourceManager.get("winningsTextMasterContainer:winningsText");
  game.loadingBackgroundLandscape = resourceManager.get("splashBackgroundL");
  game.loadingBackgroundLandscape.clearInteractiveCallbacks();
  game.loadingBackgroundPortrait = resourceManager.get("splashBackgroundP");
  game.loadingBackgroundPortrait.clearInteractiveCallbacks();

  resourceManager.getContainer("DemoContainer").visible = true;

  game.onResize();

  game.onOrientationChange();

  if (!Reflex.developerMode && gdk.deviceInfo.mobile && !gdk.isFullscreen()) {
    gdk.requestFullscreen();
  }

  if (gameController.inRecovery) {
    gameController.initNewGame(true);
  }
};

game.overrideButtons = function () {
  game.addNonNumpadSpeedControl();

  const autoplayController = resourceManager.getController("autoplayController");

  const baseStart = autoplayController.start;
  const baseCancel = autoplayController.cancel;

  autoplayController.start = function () {
    soundManager.play("buttonPressed");
    baseStart();
  };

  autoplayController.cancel = function () {
    if (game.autoplayPopupOpen) {
      soundManager.play("buttonPressed");
    }
    baseCancel();
  };

  const spinButton = resourceManager.get("uiContainer:bg:spinButton");
  spinButton.canEnableBase = spinButton.canEnable;
  spinButton.canEnable = function () {
    return this.canEnableBase() && !helpPageManager.container.visible && !game.sideMenuOpen;
  };
  const spinButtonPortrait = resourceManager.get("buttonContainerMobile:reflexButtonBar:spinButton_portrait");
  spinButtonPortrait.canEnableBase = spinButtonPortrait.canEnable;
  spinButtonPortrait.canEnable = function () {
    return this.canEnableBase() && !helpPageManager.container.visible && !game.sideMenuOpen;
  };

  const autoplayButton = resourceManager.get("uiContainer:bg:autoplayButton");
  autoplayButton.baseCanEnable = autoplayButton.canEnable;
  autoplayButton.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };
  const autoplayButtonPortrait = resourceManager.get("buttonContainerMobile:reflexButtonBar:autoplayButton_portrait");
  autoplayButtonPortrait.baseCanEnable = autoplayButtonPortrait.canEnable;
  autoplayButtonPortrait.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };

  const stakeButton = resourceManager.get("uiContainer:bg:stake");
  stakeButton.baseCanEnable = stakeButton.canEnable;
  stakeButton.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };
  const stakeButtonPortrait = resourceManager.get("buttonContainerMobile:reflexButtonBar:stake_portrait");
  stakeButtonPortrait.baseCanEnable = stakeButtonPortrait.canEnable;
  stakeButtonPortrait.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };

  const volumeButton = resourceManager.get("uiContainer:bg:volume");
  volumeButton.baseCanEnable = volumeButton.canEnable;
  volumeButton.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };
};

game.modal = function (task) {
  if (task.reason === "autoplay") {
    game.autoplayPopupOpen = true;
  } else if (task.reason === undefined || task.reason === "") {
    game.autoplayPopupOpen = false;
  }
};

game.addNonNumpadSpeedControl = function () {
  if (gdk.isDevelopmentBuild()) {
    Reflex.developerModeData.keyDownCallbacks.push(function (keycode) {
      if (!Reflex.developerModeData.manipulateCredit) {
        switch (keycode) {
          case 32: {
            // Pause/break key
            Reflex.gamePaused = !Reflex.gamePaused;
            break;
          }
          case 48: {
            // Keypad 0
            Reflex.gamePaused = !Reflex.gamePaused;
            break;
          }
          case 49: {
            // Keypad 1
            Reflex.developerModeData.speedModifier = 0.0625;
            break;
          }
          case 50: {
            // Keypad 2
            Reflex.developerModeData.speedModifier = 0.125;
            break;
          }
          case 51: {
            // Keypad 3
            Reflex.developerModeData.speedModifier = 0.25;
            break;
          }
          case 52: {
            // Keypad 4
            Reflex.developerModeData.speedModifier = 0.5;
            break;
          }
          case 53: {
            // Keypad 5
            Reflex.developerModeData.speedModifier = 1.0;
            break;
          }
          case 54: {
            // Keypad 6
            Reflex.developerModeData.speedModifier = 2.0;
            break;
          }
          case 55: {
            // Keypad 7
            Reflex.developerModeData.speedModifier = 4.0;
            break;
          }
          case 56: {
            // Keypad 8
            Reflex.developerModeData.speedModifier = 8.0;
            break;
          }
          case 57: {
            // Keypad 9
            Reflex.developerModeData.speedModifier = 16.0;
            break;
          }
          case 58: {
            // * key
            Reflex.developerModeData.speedModifier += 0.05;
            break;
          }
          case 59: {
            // / Key
            Reflex.developerModeData.speedModifier -= 0.05;
            break;
          }
          default:
            break;
        }

        if (Reflex.developerModeData.speedModifier > 256) Reflex.developerModeData.speedModifier = 256;
        if (Reflex.developerModeData.speedModifier < 0.00390625) Reflex.developerModeData.speedModifier = 0.00390625;

        if (Reflex.gamePaused || Reflex.platformPaused) {
          soundManager.pauseAllSounds();
        } else {
          soundManager.resumeAllSounds();
        }
        soundManager.setTimeScale(Reflex.developerModeData.speedModifier);
        PIXI.ticker.shared.speed = Reflex.developerModeData.speedModifier;
      }
    });
  }
};

game.changeStake = function (stake) {
  gameData.stakeMeter.set(stake);
  gdk.playerChangedStake(stake);
};

game.onHelpPagesClosed = function () {};

game.onOptionsButtonPressed = function () {
  helpPageManager.showPopup(game.onHelpPagesClosed);
};

game.onAutoplayDialogCancelled = function () {};

game.onAutoplayDialogConfirmed = function () {
  gameController.startAutoplay();
};

game.onAutoplayButtonPressed = function () {
  // If autoplay is running, cancel
  if (autoplayManager.isAutoplayEnabled()) {
    if (gameController.state === "WAITING_FOR_AUTOPLAY") {
      soundManager.play(gameData.sounds.autoplayCancel);
    } else {
      // We are autoplaying, so wait for autoplay to complete before enabling buttons
      gameData.autoplayButton.enableButton(false);
    }

    autoplayManager.stopAutoplay();
    gameController.cancelAutoplay();

    return;
  }

  // If we are in a waiting state, pop up the auto play interface
  if (gameController.state === "WAITING_FOR_START") {
    soundManager.play(gameData.sounds.autoplayPress);
    autoplayManager.openDialog(
      game.onAutoplayDialogConfirmed,
      game.onAutoplayDialogCancelled,
      gameData.coinSizes[gameData.currentStakeIndex],
      20
    );
  }
};

game.backFromReplay = function (data) {
  if (
    soundManager.sharedMode === true // we have been sharing the soundManager
  ) {
    // im going to assume the back button has been pressed during watching a replay
    // the ygg platform is telling us to unmute audio
    // stop any sounds currently playing from the old replay game
    // then clear the sharedMode flag
    // we need to restore what audio and what levels they were playing at
    // this will be down to each client to handle this as ids are stored all over the place
    // the music managers are inconsistant
    soundManager.stopAllSounds();
    soundManager.sharedMode = false;
    messageBus.postImmediate("sounds:restorePreviouslyPlayingAudio", {
      reason: "back from replay",
    });
  }
};

game.enableSpeedUp = function () {
  const caller = new Error().stack?.split("\n")[2]?.trim().split(" ")[1];
  if (caller === "GDK.readyCb") {
    document.addEventListener("keydown", (event) => {
      let validOptionPressed = true;
      if (event.key === "*") {
        game.timeScale += 0.05;
      } else if (event.key === "/") {
        game.timeScale -= 0.05;
      } else if (event.key === "-") {
        game.timeScale = 1;
      } else if (event.key === "0") {
        game.timeScale = 0;
      } else if (event.key === "1") {
        game.timeScale = 0.2;
      } else if (event.key === "2") {
        game.timeScale = 0.4;
      } else if (event.key === "3") {
        game.timeScale = 0.6;
      } else if (event.key === "4") {
        game.timeScale = 0.8;
      } else if (event.key === "5") {
        game.timeScale = 1;
      } else if (event.key === "6") {
        game.timeScale = 1.5;
      } else if (event.key === "7") {
        game.timeScale = 2;
      } else if (event.key === "8") {
        game.timeScale = 3;
      } else if (event.key === "9") {
        game.timeScale = 5;
      } else {
        validOptionPressed = false;
      }

      if (validOptionPressed) {
        if (game.timeScale > 10) game.timeScale = 10;
        if (game.timeScale < 0) game.timeScale = 0;

        console.log("Time scale: " + game.timeScale.toFixed(2));

        // not sure this bit is needed
        if (Reflex.gamePaused || Reflex.platformPaused) {
          soundManager.pauseAllSounds();
        } else {
          soundManager.resumeAllSounds();
        }
        ///////
        soundManager.setTimeScale(game.timeScale);
        gsap.globalTimeline.timeScale(game.timeScale);
        Reflex.setGameSpeed(game.timeScale);
      }
    });
  }
};

timerManager.delayAsync = async function (time, tickCallback, completeCallback, data) {
  if (!tickCallback) {
    tickCallback = (progress) => {};
  }
  if (!completeCallback) {
    completeCallback = () => {};
  }
  // cant expire it early at the moment!!!!!
  let resolver = null;
  const promise = new Promise((resolve) => {
    resolver = resolve;
  });

  const completeCB = () => {
    completeCallback();
    resolver();
  };

  const timer = timerManager.addDelayedTimer(0, time, tickCallback, completeCB, data);

  await promise;
};

standardObjectFactory.setText = function (text) {
  var oldVisible = this.visible;
  this.visible = true;
  if (this.text !== text) {
    this.text = text;
  }
  //this.text = text;
  this.checkBounds(this.Props[layoutController.getCurrentLayout()].scale);
  this.visible = oldVisible;
};
